import React from 'react';

const Loading = () =>{
    return(
        <>
        <div className="container d-flex justify-content-center align-items-center loading MainDiv">
                <div className="row  d-flex justify-content-center align-items-center">
                     <span>Loading</span>
                     <span className="firstDot">.</span>
                     <span className="secondDot">.</span>
                     <span className="thirdDot">.</span>
                </div>
            </div>
        </>
    )
}
export default Loading;